/* src/app/shared/components/table/table.component.scss */
.sort-asc,
.sort-desc,
.sort-none {
  display: block;
  height: 1rem;
  width: 1rem;
}
.sort-asc {
  background: url(/assets/images/Filter-Ascending.png);
}
.sort-desc {
  background: url(/assets/images/Filter-Desc.png);
}
.sort-none {
  background: url(/assets/images/Filter-None.png);
}
.hover-on-input-field {
  pointer-events: none;
}
.hover-on-input-field input,
.hover-on-input-field .table-select-input {
  pointer-events: auto;
}
.bi-check2-all::before {
  border-radius: 9999px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(0 143 115 / var(--tw-border-opacity, 1));
}
.bi-check2-all.tw-text-disabled-color::before {
  border-color: var(--disabled);
}
::ng-deep td.newCap,
::ng-deep .newCap input {
  width: 80px;
}
::ng-deep .white-tooltip.ant-tooltip {
  background: white !important;
  color: #000 !important;
  max-width: unset;
}
::ng-deep .white-tooltip .ant-tooltip-inner {
  background: white !important;
  color: #000 !important;
  padding: 0 !important;
  border: 1px solid #908EC1;
}
::ng-deep .white-tooltip .ant-tooltip-arrow:before {
  background: white !important;
}
::ng-deep .table-select-input.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  min-width: 50px !important;
}
::ng-deep .table-select-dropdown-reason {
  width: 22rem !important;
}
/*# sourceMappingURL=table.component.css.map */
